import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pillbox',
  templateUrl: './pillbox.component.html',
  styleUrls: ['./pillbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PillboxComponent implements OnInit {
  @Input()
  canExit = false;

  @Input()
  padding: 'none' | 'dense' | 'normal' = 'normal';

  @Input()
  orientation: 'horizontal' | 'vertical' = 'horizontal';

  @Output()
  exit = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  handleExitClick() {
    this.exit.emit();
  }

}
